module.exports = __webpack_public_path__ + "static/media/number.74c07b90.svg";